/* eslint-disable import/no-cycle */
import api from './api.service';

function index(schoolId, params) {
  return api.get(`/schools/${schoolId}/locations`, params);
}

function get(schoolId, locationId, params) {
  return api.get(`/schools/${schoolId}/locations/${locationId}`, params);
}

function propagandists(schoolId, locationId, params) {
  return api.get(`/schools/${schoolId}/locations/${locationId}/propagandists`, params);
}

function create(schoolId, params) {
  return api.post(`/schools/${schoolId}/locations`, params);
}

function update(schoolId, locationId, params) {
  return api.put(`/schools/${schoolId}/locations/${locationId}/update`, params);
}

function remove(schoolId, locationId, params) {
  return api.delete(`/schools/${schoolId}/locations/${locationId}`, params);
}

function save(params) {
  return (params.id)
  ? update(params.school_id, params.id, params)
  : create(params.school_id, params);
}

export const schoolsLocationsService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  propagandists,
};
